import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import {
    fetchLeadFormThunk,
    fetchDeliveryArticleCategoriesThunk,
    fetchDeliveryArticleTagsThunk,
    createStrapiMediaUrl,
} from 'shared/lib';
import { DeliveryPageState } from './state';
import { DeliveryPageActions, GetDeliveryServiceActionResponseMapper } from './actions';
import BaseError from '../../../utils/base-error';
import { createDeliveryArticleCardsFromGetDeliveryArticlesByCategoryAndTagApiResponse, createDeliveryArticleCategoriesFromGetDeliveryArticleCategoriesApiResponse, createDeliveryArticleTagsFromGetDeliveryArticleTagsApiResponse } from '../utils';

const initialState: DeliveryPageState = {
    loaded: false,
    errors: [],
    deliveryArticleCategories: [],
    deliveryArticlesCards: [],
    deliveryArticleTags: [],

    title: 'Доставка',
    image: {
        url: '',
    },
};

// eslint-disable-next-line import/prefer-default-export
export const deliveryPageSlice = createSlice({
    name: 'deliveryPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            DeliveryPageActions.getDeliveryArticlesByCategoryAndTag.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.deliveryArticlesCards = createDeliveryArticleCardsFromGetDeliveryArticlesByCategoryAndTagApiResponse(
                            response.data,
                        );

                        state.total = response.data.meta.pagination.total;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            DeliveryPageActions.loadMoreDeliveryArticlesByCategoryAndTag.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.deliveryArticlesCards = [
                            ...state.deliveryArticlesCards,
                            // eslint-disable-next-line max-len
                            ...createDeliveryArticleCardsFromGetDeliveryArticlesByCategoryAndTagApiResponse(
                                response.data,
                            ),
                        ];

                        state.total = response.data.meta.pagination.total;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchDeliveryArticleCategoriesThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.deliveryArticleCategories = createDeliveryArticleCategoriesFromGetDeliveryArticleCategoriesApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchDeliveryArticleTagsThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        // eslint-disable-next-line max-len
                        state.deliveryArticleTags = createDeliveryArticleTagsFromGetDeliveryArticleTagsApiResponse(
                            response.data,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            DeliveryPageActions.getDeliveryService.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        state.title = GetDeliveryServiceActionResponseMapper.getTitle(
                            response,
                        );
                        state.description = GetDeliveryServiceActionResponseMapper.getDescription(
                            response,
                        );
                        state.image = GetDeliveryServiceActionResponseMapper.getImage(
                            response,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
    },
});
